export function getDeviceType(): 'mobile' | 'tablet' | 'desktop' {
	const ua = navigator.userAgent;
	if (/tablet|ipad|playbook|silk/i.test(ua)) return 'tablet';
	if (/mobile|iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(ua)) return 'mobile';
	return 'desktop';
}
